export default class KingdomRoles {
	static governor = 'governor';
	static duke = 'duke';
	static king = 'king';
}
